import React, { useState, useEffect, useRef } from 'react';
import { supabase } from './supabase';
import './Hauler.css';

const BACKEND = 'https://tambo-production-826b.up.railway.app';

function IconHome({ active }) {
  const c = active ? '#1A7A4A' : '#9CA3AF';
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12L3 12L12 3L21 12L19 12"/>
      <path d="M5 12V19C5 19.5523 5.44772 20 6 20H9V16C9 15.4477 9.44772 15 10 15H14C14.5523 15 15 15.4477 15 16V20H18C18.5523 20 19 19.5523 19 19V12"/>
    </svg>
  );
}

function IconBriefcase({ active }) {
  const c = active ? '#1A7A4A' : '#9CA3AF';
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="7" width="18" height="13" rx="2"/>
      <path d="M8 7V5C8 4.44772 8.44772 4 9 4H15C15.5523 4 16 4.44772 16 5V7"/>
      <line x1="3" y1="12" x2="21" y2="12"/>
    </svg>
  );
}

function IconCalendar({ active }) {
  const c = active ? '#1A7A4A' : '#9CA3AF';
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="5" width="16" height="16" rx="2"/>
      <line x1="16" y1="3" x2="16" y2="7"/>
      <line x1="8" y1="3" x2="8" y2="7"/>
      <line x1="4" y1="11" x2="20" y2="11"/>
    </svg>
  );
}

function IconCoin({ active }) {
  const c = active ? '#1A7A4A' : '#9CA3AF';
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9"/>
      <path d="M14.5 9C14.5 9 13.5 8 12 8C9.5 8 9 9.5 9 10.5C9 13 15 12 15 14.5C15 15.5 14 16.5 12 16.5C10 16.5 9 15.5 9 15"/>
      <line x1="12" y1="6.5" x2="12" y2="8"/>
      <line x1="12" y1="16.5" x2="12" y2="18"/>
    </svg>
  );
}

function IconUser({ active }) {
  const c = active ? '#1A7A4A' : '#9CA3AF';
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="7" r="4"/>
      <path d="M4 21C4 17.134 7.58172 14 12 14C16.4183 14 20 17.134 20 21"/>
    </svg>
  );
}

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleLogin = async function() {
    if (!email || !password) { setError('Please enter email and password'); return; }
    setLoading(true);
    const result = await supabase.auth.signInWithPassword({ email, password });
    if (result.error) { setError(result.error.message); setLoading(false); return; }
    onLogin(result.data.user);
    setLoading(false);
  };

  return (
    <div className="h-login">
      <div className="h-login-hero">
        <div className="h-login-logo" onClick={function(){window.location.href='/';}} style={{cursor:'pointer'}}>Tam<span>bo</span></div>
        <p className="h-login-tagline">Hauler Portal</p>
      </div>
      <div className="h-login-body">
        <div className="h-login-title">Welcome back</div>
        <p className="h-login-sub">Sign in to see your jobs</p>
        <div className="h-field">
          <label>Email</label>
          <input type="email" placeholder="you@company.com" value={email} onChange={function(e){setEmail(e.target.value);}}/>
        </div>
        <div className="h-field">
          <label>Password</label>
          <div style={{ position: 'relative' }}>
            <input type={showPwd ? 'text' : 'password'} placeholder="Your password" value={password} onChange={function(e){setPassword(e.target.value);}} style={{ paddingRight: 40, boxSizing: 'border-box', width: '100%' }}/>
            <button type="button" onClick={function() { setShowPwd(function(v) { return !v; }); }} tabIndex={-1} aria-label={showPwd ? 'Hide password' : 'Show password'} style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#9ca3af', lineHeight: 0 }}>
              {showPwd
                ? <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                : <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              }
            </button>
          </div>
        </div>
        {error && <div className="h-error">{error}</div>}
        <button className="h-btn" onClick={handleLogin} disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </div>
    </div>
  );
}

function PendingPage({ onSignOut }) {
  return (
    <div style={{background:'#FAFAF8',minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'32px 24px',textAlign:'center',fontFamily:'sans-serif'}}>
      <div style={{fontSize:'26px',fontWeight:'800',color:'#0D0D0D',marginBottom:'32px'}}>
        Tam<span style={{color:'#1A7A4A'}}>bo</span>
      </div>
      <div style={{width:'72px',height:'72px',background:'#FFF8E1',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px',marginBottom:'20px'}}>⏳</div>
      <div style={{fontSize:'20px',fontWeight:'800',color:'#0D0D0D',marginBottom:'10px'}}>Your Account is Pending Approval</div>
      <div style={{fontSize:'14px',color:'#6B6B6B',maxWidth:'300px',lineHeight:'1.7',marginBottom:'8px'}}>
        We'll notify you by email and text once you're approved.
      </div>
      <div style={{fontSize:'14px',color:'#6B6B6B',maxWidth:'300px',lineHeight:'1.7',marginBottom:'36px'}}>
        Questions? Call us at <a href="tel:+19562753688" style={{color:'#1A7A4A',fontWeight:'600',textDecoration:'none'}}>+1 (956) 275-3688</a>
      </div>
      <button onClick={onSignOut} style={{background:'#ef4444',color:'white',border:'none',borderRadius:'10px',padding:'12px 28px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>
        Log Out
      </button>
    </div>
  );
}

function SuspendedPage({ onSignOut }) {
  return (
    <div style={{background:'#FAFAF8',minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',padding:'32px 24px',textAlign:'center',fontFamily:'sans-serif'}}>
      <div style={{fontSize:'26px',fontWeight:'800',color:'#0D0D0D',marginBottom:'32px'}}>
        Tam<span style={{color:'#1A7A4A'}}>bo</span>
      </div>
      <div style={{width:'72px',height:'72px',background:'#FEF3C7',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'32px',marginBottom:'20px'}}>🚫</div>
      <div style={{fontSize:'20px',fontWeight:'800',color:'#0D0D0D',marginBottom:'10px'}}>Account Suspended</div>
      <div style={{fontSize:'14px',color:'#6B6B6B',maxWidth:'300px',lineHeight:'1.7',marginBottom:'8px'}}>
        Your hauler account has been suspended. You cannot receive job dispatches at this time.
      </div>
      <div style={{fontSize:'14px',color:'#6B6B6B',maxWidth:'300px',lineHeight:'1.7',marginBottom:'36px'}}>
        Please call us at <a href="tel:+19562263903" style={{color:'#1A7A4A',fontWeight:'600',textDecoration:'none'}}>(956) 226-3903</a> for more information.
      </div>
      <button onClick={onSignOut} style={{background:'#ef4444',color:'white',border:'none',borderRadius:'10px',padding:'12px 28px',fontSize:'14px',fontWeight:'700',cursor:'pointer'}}>
        Log Out
      </button>
    </div>
  );
}

function JobDetailPage({ orderId, user, onBack }) {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [delivering, setDelivering] = useState(false);
  const [delivered, setDelivered] = useState(false);
  const [completing, setCompleting] = useState(false);
  const [pickupDone, setPickupDone] = useState(false);
  const [error, setError] = useState('');

  useEffect(function() {
    if (!user || !orderId) return;
    fetch(BACKEND + '/api/haulers/order/' + orderId + '?user_id=' + user.id)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.order) {
          setOrder(data.order);
          setDelivered(data.order.status === 'delivered');
        } else {
          setError(data.error || 'Order not found');
        }
        setLoading(false);
      })
      .catch(function() {
        setError('Could not load job details. Check your connection.');
        setLoading(false);
      });
  }, [orderId, user]);

  const markDelivered = async function() {
    setDelivering(true);
    setError('');
    try {
      const res = await fetch(BACKEND + '/api/haulers/order/' + orderId + '/delivered', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id })
      });
      const data = await res.json();
      if (data.success) {
        setDelivered(true);
        setOrder(function(prev) { return Object.assign({}, prev, { status: 'delivered' }); });
      } else {
        setError(data.error || 'Failed to update status');
      }
    } catch(e) {
      setError('Network error. Please try again.');
    }
    setDelivering(false);
  };

  const markPickupComplete = async function() {
    setCompleting(true);
    setError('');
    try {
      const res = await fetch(BACKEND + '/api/haulers/order/' + orderId + '/complete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id })
      });
      const data = await res.json();
      if (data.success) {
        setPickupDone(true);
        setOrder(function(prev) { return Object.assign({}, prev, { status: 'completed' }); });
        setTimeout(onBack, 1800);
      } else {
        setError(data.error || 'Failed to mark pickup complete');
      }
    } catch(e) {
      setError('Network error. Please try again.');
    }
    setCompleting(false);
  };

  const durationLabel = function(d) {
    const map = { '3_day': '3-Day', '5_day': '5-Day', '7_day': '7-Day' };
    return map[d] || d || '—';
  };

  const formatDeliveryDate = function(dateStr) {
    if (!dateStr) return '—';
    const parts = String(dateStr).split('T')[0].split('-').map(Number);
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    if (d.toDateString() === today.toDateString()) return 'Today';
    if (d.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
    return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
  };

  const windowLabel = function(start, end) {
    const fmt = function(t) {
      if (!t) return '';
      const h = parseInt(t.split(':')[0], 10);
      const ampm = h >= 12 ? 'pm' : 'am';
      const h12 = h > 12 ? h - 12 : h === 0 ? 12 : h;
      return h12 + ampm;
    };
    if (!start) return '—';
    return fmt(start) + ' – ' + fmt(end);
  };

  const windowName = function(start) {
    if (start === '08:00') return 'Morning';
    if (start === '12:00') return 'Afternoon';
    if (start === '16:00') return 'Evening';
    return '';
  };

  return (
    <div className="h-app">
      <header className="h-header">
        <button className="h-header-back" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18L9 12L15 6"/>
          </svg>
        </button>
        <div className="h-header-name" style={{textAlign:'left',paddingLeft:'4px'}}>Job Details</div>
      </header>

      <main className="h-main" style={{paddingBottom:'20px'}}>
        {loading && (
          <div className="h-empty"><div className="h-empty-icon">⏳</div><div>Loading job details...</div></div>
        )}
        {!loading && !order && (
          <div className="h-empty">
            <div className="h-empty-icon">⚠️</div>
            <div className="h-empty-title">Job not found</div>
            {error && <div>{error}</div>}
          </div>
        )}
        {!loading && order && (
          <div style={{padding:'16px 14px'}}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'20px'}}>
              <div style={{fontSize:'16px',fontWeight:'800',color:'#0D0D0D'}}>Job #{order.order_number}</div>
              <span className={'h-badge ' + (delivered ? 'delivered' : 'progress')}>
                {delivered ? 'Delivered' : 'In Progress'}
              </span>
            </div>

            <div className="h-card" style={{marginBottom:'14px'}}>
              <div className="h-card-title">Delivery Details</div>
              <div style={{background:'#1A7A4A',borderRadius:'10px',padding:'14px',marginBottom:'14px'}}>
                <div style={{fontSize:'10px',color:'rgba(255,255,255,0.7)',fontWeight:'700',letterSpacing:'0.5px',marginBottom:'4px'}}>DELIVER ON</div>
                <div style={{fontSize:'19px',fontWeight:'800',color:'white',marginBottom:'3px'}}>{formatDeliveryDate(order.requested_delivery_date)}</div>
                <div style={{fontSize:'14px',color:'rgba(255,255,255,0.9)',fontWeight:'600'}}>
                  {windowName(order.delivery_window_start)}{windowName(order.delivery_window_start) ? ' · ' : ''}{windowLabel(order.delivery_window_start, order.delivery_window_end)}
                </div>
              </div>
              <div style={{marginBottom:'12px'}}>
                <div className="h-form-label">Address</div>
                <div style={{fontSize:'14px',fontWeight:'600',color:'#0D0D0D'}}>{order.delivery_address}</div>
                <div style={{fontSize:'12px',color:'#6B6B6B'}}>{order.delivery_zip}</div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
                <div>
                  <div className="h-form-label">Size</div>
                  <div style={{fontSize:'14px',fontWeight:'600',color:'#0D0D0D'}}>{order.size}</div>
                </div>
                <div>
                  <div className="h-form-label">Duration</div>
                  <div style={{fontSize:'14px',fontWeight:'600',color:'#0D0D0D'}}>{durationLabel(order.duration)}</div>
                </div>
              </div>
              <div>
                <div className="h-form-label">Waste Type</div>
                <div style={{fontSize:'14px',fontWeight:'600',color:'#0D0D0D'}}>{order.waste_type || 'General debris'}</div>
              </div>
              {order.access_notes && (
                <div style={{marginTop:'12px',paddingTop:'12px',borderTop:'1px solid #E5E5E0'}}>
                  <div className="h-form-label">Access Notes</div>
                  <div style={{fontSize:'13px',color:'#0D0D0D'}}>{order.access_notes}</div>
                </div>
              )}
              {order.special_instructions && (
                <div style={{marginTop:'12px',paddingTop:'12px',borderTop:'1px solid #E5E5E0'}}>
                  <div className="h-form-label">Special Instructions</div>
                  <div style={{fontSize:'13px',color:'#0D0D0D',whiteSpace:'pre-wrap',lineHeight:'1.5'}}>{order.special_instructions}</div>
                </div>
              )}
              {order.placement_lat && order.placement_lng && (
                <div style={{marginTop:'12px',paddingTop:'12px',borderTop:'1px solid #E5E5E0'}}>
                  <div className="h-form-label">Placement Location</div>
                  <img
                    src={`${BACKEND}/api/placement-map/${order.id}`}
                    alt="Dumpster placement"
                    style={{width:'100%',borderRadius:'8px',marginTop:'6px',display:'block'}}
                  />
                </div>
              )}
            </div>

            <div className="h-card" style={{marginBottom:'20px'}}>
              <div className="h-card-title">Your Payout</div>
              <div style={{fontSize:'32px',fontWeight:'800',color:'#1A7A4A'}}>${parseFloat(order.hauler_payout || 0).toFixed(2)}</div>
            </div>

            {error && <div className="h-error">{error}</div>}

            {pickupDone ? (
              <div className="h-success" style={{textAlign:'center',fontSize:'15px',padding:'16px'}}>Pickup complete — great work!</div>
            ) : order && (order.status === 'delivered' || order.status === 'active') ? (
              <>
                <div className="h-success" style={{marginBottom:'10px'}}>Delivered — awaiting client pickup request.</div>
                <button className="h-btn" onClick={markPickupComplete} disabled={completing}>
                  {completing ? 'Updating...' : 'Mark Pickup Complete'}
                </button>
              </>
            ) : delivered || (order && order.status === 'delivered') ? (
              <div className="h-success" style={{textAlign:'center',fontSize:'15px',padding:'16px'}}>Delivered — great work!</div>
            ) : (
              <button className="h-btn" onClick={markDelivered} disabled={delivering}>
                {delivering ? 'Updating...' : 'Mark as Delivered'}
              </button>
            )}
          </div>
        )}
      </main>
    </div>
  );
}

const SIZES = ['7yd','10yd','11yd','13yd','14yd','15yd','17yd','20yd','21yd','25yd','30yd','40yd'];
const SIZE_LABELS = {'7yd':'7-Yard (Concrete)','10yd':'10-Yard','11yd':'11-Yard','13yd':'13-Yard','14yd':'14-Yard','15yd':'15-Yard','17yd':'17-Yard','20yd':'20-Yard','21yd':'21-Yard','25yd':'25-Yard','30yd':'30-Yard','40yd':'40-Yard'};

function HaulerDashboard({ user, onSignOut }) {
  const [tab, setTab] = useState('home');
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [dashboardTick, setDashboardTick] = useState(0);

  // Dashboard state (from original HomePage)
  const [stats, setStats] = useState({ active: 0, week_earnings: 0, board_count: 0 });
  const [schedule, setSchedule] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
  const [completed, setCompleted] = useState([]);
  const [offered, setOffered] = useState([]);
  const [awaitingPickup, setAwaitingPickup] = useState([]);

  // Load board state (from original LoadBoardPage)
  const [loadJobs, setLoadJobs] = useState([]);
  const [boardLoading, setBoardLoading] = useState(true);

  // Profile state (from original ProfilePage)
  const [companyName, setCompanyName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [email] = useState(user ? user.email : '');
  const [homeBaseCity, setHomeBaseCity] = useState('');
  const [serviceRadius, setServiceRadius] = useState(35);
  const [locationSaved, setLocationSaved] = useState(false);
  const [profileSaving, setProfileSaving] = useState(false);
  const [profileSaved, setProfileSaved] = useState(false);
  const [profileError, setProfileError] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [newPwdConfirm, setNewPwdConfirm] = useState('');
  const [pwdSaving, setPwdSaving] = useState(false);
  const [pwdSaved, setPwdSaved] = useState(false);
  const [pwdError, setPwdError] = useState('');

  // Inventory state (from original InventoryPage)
  const [inventory, setInventory] = useState({});

  const [completedVisible, setCompletedVisible] = useState(10);
  const [payoutVisible, setPayoutVisible] = useState(10);
  const completedListRef = useRef(null);
  const payoutListRef = useRef(null);
  const [jobRatings, setJobRatings] = useState({}); // { [orderId]: { hover, selected, submitting, error } }
  const [zips, setZips] = useState('');
  const [inventorySaving, setInventorySaving] = useState(false);
  const [inventorySaved, setInventorySaved] = useState(false);

  // Rates modal state
  const [ratesModal, setRatesModal] = useState(null);
  const [ratesDraft, setRatesDraft] = useState({
    rate_3day:'', rate_5day:'', rate_7day:'', rate_extra_day:'',
    included_days:'3', included_tonnage:'', daily_rate:'', overage_per_ton:'',
  });
  const [ratesSaving, setRatesSaving] = useState(false);
  const [ratesSaved, setRatesSaved] = useState(false);

  // Dashboard useEffect — re-runs whenever dashboardTick increments (e.g. after grab or pickup complete)
  useEffect(function() {
    if (!user) return;
    fetch(BACKEND + '/api/haulers/dashboard?user_id=' + user.id)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.stats) setStats(data.stats);
        setSchedule(data.schedule || []);
        setUpcoming(data.upcoming || []);
        setCompleted(data.completed || []);
        setOffered(data.offered || []);
        setAwaitingPickup(data.awaitingPickup || []);
      })
      .catch(function(e) { console.error(e); });
  }, [user, dashboardTick]); // eslint-disable-line react-hooks/exhaustive-deps

  // Load board useEffect (from original LoadBoardPage)
  useEffect(function() {
    if (!user) return;
    fetch(BACKEND + '/api/haulers/loadboard?user_id=' + user.id)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        setLoadJobs(data.jobs || []);
        setBoardLoading(false);
      })
      .catch(function() { setBoardLoading(false); });
  }, [user]);

  // Profile + inventory useEffect (from original ProfilePage + InventoryPage)
  useEffect(function() {
    if (!user) return;
    const meta = user.user_metadata || {};
    fetch(BACKEND + '/api/haulers/me?user_id=' + user.id)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.hauler) {
          setCompanyName(data.hauler.company_name || '');
          setPhone(data.hauler.phone || '');
          setServiceRadius(data.hauler.service_radius_miles || 35);
          setHomeBaseCity(data.hauler.home_base_city || '');
          setLocationSaved(!!(data.hauler.base_lat && data.hauler.base_lng));
          setZips((data.hauler.service_zips || []).join(', '));
        }
        setFirstName(data.user?.first_name || meta.first_name || '');
        setLastName(data.user?.last_name   || meta.last_name  || '');
        const inv = {};
        (data.inventory || []).forEach(function(item) { inv[item.size] = item; });
        setInventory(inv);
      });
  }, [user]);

  // handleGrab (from original LoadBoardPage)
  const handleGrab = async function(orderId) {
    try {
      const res = await fetch(BACKEND + '/api/haulers/grab', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, order_id: orderId })
      });
      const data = await res.json();
      if (data.success) {
        setLoadJobs(function(prev) { return prev.filter(function(j) { return j.id !== orderId; }); });
        setDashboardTick(function(t) { return t + 1; }); // refresh accepted jobs
      } else {
        alert(data.error || 'Could not grab job');
      }
    } catch(e) { console.error(e); }
  };

  const handleAccept = async function(orderId) {
    try {
      const res = await fetch(BACKEND + '/api/haulers/order/' + orderId + '/accept', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id })
      });
      const data = await res.json();
      if (data.success) {
        setOffered(function(prev) { return prev.filter(function(j) { return j.id !== orderId; }); });
        setDashboardTick(function(t) { return t + 1; });
      } else {
        alert(data.error || 'Could not accept job');
      }
    } catch(e) { console.error(e); }
  };

  const handleDecline = async function(orderId) {
    try {
      const res = await fetch(BACKEND + '/api/haulers/order/' + orderId + '/decline', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id })
      });
      const data = await res.json();
      if (data.success) {
        setOffered(function(prev) { return prev.filter(function(j) { return j.id !== orderId; }); });
      } else {
        alert(data.error || 'Could not decline job');
      }
    } catch(e) {
      console.error(e);
      alert('Network error — could not decline job. Please try again.');
    }
  };

  const handlePickupComplete = async function(orderId) {
    try {
      const res = await fetch(BACKEND + '/api/haulers/order/' + orderId + '/complete', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id })
      });
      const data = await res.json();
      if (data.success) {
        setDashboardTick(function(t) { return t + 1; }); // restore inventory + refresh lists
      } else {
        alert(data.error || 'Could not mark pickup complete');
      }
    } catch(e) { console.error(e); }
  };

  const rateClient = async function(job, star) {
    setJobRatings(function(prev) { return Object.assign({}, prev, { [job.id]: Object.assign({}, prev[job.id], { submitting: true, error: null }) }); });
    try {
      const res = await fetch(BACKEND + '/api/haulers/rate-client', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, order_id: job.id, rating: star }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Failed to submit rating');
      setJobRatings(function(prev) { return Object.assign({}, prev, { [job.id]: { selected: star, submitted: true, submitting: false } }); });
    } catch(err) {
      setJobRatings(function(prev) { return Object.assign({}, prev, { [job.id]: Object.assign({}, prev[job.id], { submitting: false, error: err.message }) }); });
    }
  };

  // handleSaveProfile (from original ProfilePage)
  const handleSaveProfile = async function() {
    if (!firstName || !lastName || !phone) {
      setProfileError('Please fill in your name and phone');
      return;
    }
    setProfileSaving(true);
    setProfileError('');
    try {
      let base_lat = null;
      let base_lng = null;
      const cityStr = homeBaseCity.trim();

      if (cityStr) {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
        const geoRes = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(cityStr)}&key=${apiKey}`
        );
        const geoData = await geoRes.json();
        if (geoData.results?.[0]?.geometry?.location) {
          base_lat = geoData.results[0].geometry.location.lat;
          base_lng = geoData.results[0].geometry.location.lng;
        } else {
          setProfileError('Could not find that city — try "Harlingen, TX" format.');
          setProfileSaving(false);
          return;
        }
      }

      const payload = {
        user_id: user.id,
        company_name: companyName.trim() || null,
        first_name: firstName,
        last_name: lastName,
        phone,
        base_lat,
        base_lng,
        home_base_city: cityStr || null,
        service_radius_miles: serviceRadius,
      };
      console.log('[profile save] sending payload:', payload);

      const res = await fetch(BACKEND + '/api/haulers/profile', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      console.log('[profile save] response status:', res.status, 'body:', data);
      if (!res.ok) { setProfileError(data.error || 'Failed to save'); setProfileSaving(false); return; }
      if (base_lat) setLocationSaved(true);
      setProfileSaved(true);
      setTimeout(function() { setProfileSaved(false); }, 3000);
    } catch(e) {
      console.error('[profile save] caught error:', e);
      setProfileError('Network error. Please try again.');
    }
    setProfileSaving(false);
  };

  // updateInv (from original InventoryPage)
  const updateInv = function(size, field, value) {
    setInventory(function(prev) {
      const next = Object.assign({}, prev);
      if (!next[size]) next[size] = { size, quantity:1, rate_3day:0, rate_5day:0, rate_7day:0, rate_extra_day:0, is_available:true };
      next[size] = Object.assign({}, next[size], { [field]: value });
      return next;
    });
  };

  const handleChangePassword = async function() {
    if (!newPwd || newPwd.length < 8) { setPwdError('Password must be at least 8 characters. / La contraseña debe tener al menos 8 caracteres.'); return; }
    if (newPwd !== newPwdConfirm) { setPwdError('Passwords do not match. / Las contraseñas no coinciden.'); return; }
    setPwdSaving(true);
    setPwdError('');
    const { error } = await supabase.auth.updateUser({ password: newPwd });
    if (error) { setPwdError(error.message); setPwdSaving(false); return; }
    setPwdSaved(true);
    setNewPwd('');
    setNewPwdConfirm('');
    setPwdSaving(false);
    setTimeout(function() { setPwdSaved(false); }, 4000);
  };

  // handleSaveInventory (from original InventoryPage)
  const handleSaveInventory = async function() {
    setInventorySaving(true);
    try {
      const zipArray = zips.split(',').map(function(z) { return z.trim(); }).filter(Boolean);
      await fetch(BACKEND + '/api/haulers/zips', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, service_zips: zipArray })
      });
      for (const size of SIZES) {
        if (inventory[size]) {
          await fetch(BACKEND + '/api/haulers/inventory', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              user_id: user.id, size,
              quantity: parseInt(inventory[size].quantity) || 1,
              rate_3day: parseFloat(inventory[size].rate_3day) || 0,
              rate_5day: parseFloat(inventory[size].rate_5day) || 0,
              rate_7day: parseFloat(inventory[size].rate_7day) || 0,
              rate_extra_day: parseFloat(inventory[size].rate_extra_day) || 0,
              is_available: inventory[size].is_available !== false,
            })
          });
        }
      }
      setInventorySaved(true);
      setTimeout(function() { setInventorySaved(false); }, 3000);
    } catch(e) { console.error(e); }
    setInventorySaving(false);
  };

  const openRatesModal = function(size) {
    const item = inventory[size] || {};
    setRatesDraft({
      rate_3day:       item.rate_3day       != null ? String(item.rate_3day)       : '',
      rate_5day:       item.rate_5day       != null ? String(item.rate_5day)       : '',
      rate_7day:       item.rate_7day       != null ? String(item.rate_7day)       : '',
      rate_extra_day:  item.rate_extra_day  != null ? String(item.rate_extra_day)  : '',
      included_days:   item.included_days   != null ? String(item.included_days)   : '3',
      included_tonnage:item.included_tonnage!= null ? String(item.included_tonnage): '',
      daily_rate:      item.daily_rate      != null ? String(item.daily_rate)      : '',
      overage_per_ton: item.overage_per_ton != null ? String(item.overage_per_ton) : '',
    });
    setRatesSaved(false);
    setRatesModal(size);
  };

  const handleSaveRates = async function() {
    const size = ratesModal;
    setRatesSaving(true);
    try {
      const item = inventory[size] || {};
      await fetch(BACKEND + '/api/haulers/inventory', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: user.id, size,
          quantity: parseInt(item.quantity) || 1,
          rate_3day:        parseFloat(ratesDraft.rate_3day)        || 0,
          rate_5day:        parseFloat(ratesDraft.rate_5day)        || 0,
          rate_7day:        parseFloat(ratesDraft.rate_7day)        || 0,
          rate_extra_day:   parseFloat(ratesDraft.rate_extra_day)   || 0,
          included_days:    parseInt(ratesDraft.included_days)      || 3,
          included_tonnage: parseFloat(ratesDraft.included_tonnage) || 0,
          daily_rate:       parseFloat(ratesDraft.daily_rate)       || 0,
          overage_per_ton:  parseFloat(ratesDraft.overage_per_ton)  || 0,
          is_available: item.is_available !== false,
        })
      });
      setInventory(function(prev) {
        const next = Object.assign({}, prev);
        const cur = next[size] || { size, quantity:1, is_available:true };
        next[size] = Object.assign({}, cur, {
          rate_3day:        parseFloat(ratesDraft.rate_3day)        || 0,
          rate_5day:        parseFloat(ratesDraft.rate_5day)        || 0,
          rate_7day:        parseFloat(ratesDraft.rate_7day)        || 0,
          rate_extra_day:   parseFloat(ratesDraft.rate_extra_day)   || 0,
          included_days:    parseInt(ratesDraft.included_days)      || 3,
          included_tonnage: parseFloat(ratesDraft.included_tonnage) || 0,
          daily_rate:       parseFloat(ratesDraft.daily_rate)       || 0,
          overage_per_ton:  parseFloat(ratesDraft.overage_per_ton)  || 0,
        });
        return next;
      });
      setRatesSaved(true);
      setTimeout(function() { setRatesModal(null); setRatesSaved(false); }, 1200);
    } catch(e) { console.error(e); }
    setRatesSaving(false);
  };

  const formatDate = function(dateStr) {
    if (!dateStr) return '—';
    const parts = String(dateStr).split('T')[0].split('-').map(Number);
    const d = new Date(parts[0], parts[1] - 1, parts[2]);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    if (d.toDateString() === today.toDateString()) return 'Today';
    if (d.toDateString() === tomorrow.toDateString()) return 'Tomorrow';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  if (selectedJobId) {
    return (
      <JobDetailPage
        orderId={selectedJobId}
        user={user}
        onBack={function() { setSelectedJobId(null); }}
      />
    );
  }

  const displayName = companyName.trim() || firstName || 'Hauler';

  const totalEarned = completed.reduce(function(sum, j) { return sum + parseFloat(j.hauler_payout || 0); }, 0);
  const now = new Date();
  const monthEarned = completed
    .filter(function(j) {
      const d = new Date(j.actual_delivered_at || j.requested_delivery_date);
      return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    })
    .reduce(function(sum, j) { return sum + parseFloat(j.hauler_payout || 0); }, 0);

  return (
    <div className="h-app">
      <header className="h-header">
        <div className="h-header-logo" onClick={function(){ setTab('home'); }} style={{cursor:'pointer'}}>Tam<span>bo</span></div>
        <div className="h-header-name">Hello, {displayName}</div>
        <button className="h-header-logout" onClick={onSignOut}>Logout</button>
      </header>

      <main className="h-main">

        {/* HOME TAB */}
        {tab === 'home' && (
          <div>
            <div className="h-stat-row">
              <div className="h-stat-card">
                <div className="h-stat-val">{stats.active}</div>
                <div className="h-stat-lbl">Active Jobs</div>
              </div>
              <div className="h-stat-card green">
                <div className="h-stat-val">${stats.week_earnings}</div>
                <div className="h-stat-lbl">This Week</div>
              </div>
              <div className="h-stat-card">
                <div className="h-stat-val">{completed.length}</div>
                <div className="h-stat-lbl">Completed</div>
              </div>
            </div>

            {awaitingPickup.length > 0 && (
              <div className="h-section">
                <div className="h-section-hd" style={{color:'#DC2626'}}>Pickup Requested</div>
                {awaitingPickup.map(function(job) {
                  return (
                    <div key={job.id} style={{background:'#FEF2F2',border:'2px solid #EF4444',borderRadius:'12px',padding:'14px',marginBottom:'10px'}}>
                      <div style={{fontSize:'12px',fontWeight:'700',color:'#DC2626',marginBottom:'6px',letterSpacing:'.3px'}}>PICKUP REQUESTED — client is ready for pickup</div>
                      <div style={{fontSize:'15px',fontWeight:'700',color:'#0D0D0D',marginBottom:'2px'}}>{job.delivery_address}</div>
                      <div style={{fontSize:'13px',color:'#6B6B6B',marginBottom:'10px'}}>{job.size} · ${parseFloat(job.hauler_payout || 0).toFixed(0)} payout</div>
                      <button
                        onClick={function() { handlePickupComplete(job.id); }}
                        style={{width:'100%',padding:'10px',background:'#DC2626',color:'white',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                        Mark Pickup Complete
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            {offered.length > 0 && (
              <div className="h-section">
                <div className="h-section-hd" style={{color:'#D97706'}}>Job Offered to You</div>
                {offered.map(function(job) {
                  return (
                    <div key={job.id} style={{background:'#FFFBEB',border:'2px solid #F59E0B',borderRadius:'12px',padding:'14px',marginBottom:'10px'}}>
                      <div style={{fontSize:'12px',fontWeight:'700',color:'#D97706',marginBottom:'6px',letterSpacing:'.3px'}}>ACTION REQUIRED — Accept or decline this job</div>
                      <div style={{fontSize:'15px',fontWeight:'700',color:'#0D0D0D',marginBottom:'2px'}}>{job.delivery_address}</div>
                      <div style={{fontSize:'13px',color:'#6B6B6B',marginBottom:'8px'}}>{job.size} · {formatDate(job.requested_delivery_date)} · ${parseFloat(job.hauler_payout || 0).toFixed(0)} payout</div>
                      <div style={{display:'flex',gap:'8px'}}>
                        <button
                          onClick={function() { handleAccept(job.id); }}
                          style={{flex:1,padding:'9px',background:'#1A7A4A',color:'white',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                          Accept Job
                        </button>
                        <button
                          onClick={function() { handleDecline(job.id); }}
                          style={{flex:1,padding:'9px',background:'white',color:'#EF4444',border:'1.5px solid #EF4444',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                          Decline
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {upcoming.length > 0 && (
              <div className="h-section">
                <div className="h-section-hd">Next Delivery</div>
                <div className="h-upcoming-card" onClick={function() { setSelectedJobId(upcoming[0].id); }} style={{cursor:'pointer'}}>
                  <div className="h-upcoming-label">DELIVER ON</div>
                  <div className="h-upcoming-date">{formatDate(upcoming[0].requested_delivery_date)}</div>
                  <div className="h-upcoming-addr">{upcoming[0].delivery_address}</div>
                  <div className="h-upcoming-meta">{upcoming[0].size} · ${parseFloat(upcoming[0].hauler_payout || 0).toFixed(0)} payout</div>
                </div>
              </div>
            )}

            <div className="h-section">
              <div className="h-section-hd" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span>Available Near You</span>
                {loadJobs.length > 2 && (
                  <span onClick={function() { setTab('jobs'); }} style={{fontSize:'11px',color:'#1A7A4A',fontWeight:'600',cursor:'pointer'}}>
                    See all {loadJobs.length} →
                  </span>
                )}
              </div>
              {boardLoading && <div style={{color:'#6B6B6B',fontSize:'13px'}}>Loading...</div>}
              {!boardLoading && loadJobs.length === 0 && (
                <div style={{color:'#6B6B6B',fontSize:'13px'}}>No jobs on the board right now.</div>
              )}
              {loadJobs.slice(0, 2).map(function(job) {
                return (
                  <div className="h-board-card" key={job.id}>
                    <div className="h-board-info">
                      <div className="h-board-addr">{job.delivery_address}</div>
                      <div className="h-board-meta">{job.size} · {job.duration} · {job.waste_type || 'General debris'}</div>
                    </div>
                    <div className="h-board-right">
                      <div className="h-board-payout">${job.hauler_payout || 'TBD'}</div>
                      <button className="h-grab-btn" onClick={function() { handleGrab(job.id); }}>Grab</button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* JOBS TAB */}
        {tab === 'jobs' && (
          <div>
            <div className="h-section" style={{paddingTop:'16px'}}>
              <div className="h-section-hd" style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <span>Available Jobs</span>
                <span className="h-count-pill">{loadJobs.length}</span>
              </div>
              {boardLoading && <div style={{color:'#6B6B6B',fontSize:'13px'}}>Loading...</div>}
              {!boardLoading && loadJobs.length === 0 && (
                <div className="h-empty">
                  <div className="h-empty-icon">📋</div>
                  <div className="h-empty-title">No jobs on the board</div>
                  <div>Check back soon — new orders appear here!</div>
                </div>
              )}
              {loadJobs.map(function(job) {
                return (
                  <div className="h-board-card" key={job.id}>
                    <div className="h-board-info">
                      <div className="h-board-addr">{job.delivery_address}</div>
                      <div className="h-board-meta">{job.size} · {job.duration} · {job.waste_type || 'General debris'}</div>
                      <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'2px'}}>Ordered {new Date(job.created_at).toLocaleDateString()}</div>
                    </div>
                    <div className="h-board-right">
                      <div className="h-board-payout">${job.hauler_payout || 'TBD'}</div>
                      <button className="h-grab-btn" onClick={function() { handleGrab(job.id); }}>Grab it</button>
                    </div>
                  </div>
                );
              })}
            </div>

            {awaitingPickup.length > 0 && (
              <div className="h-section">
                <div className="h-section-hd" style={{color:'#DC2626'}}>Pickup Requested</div>
                {awaitingPickup.map(function(job) {
                  return (
                    <div key={job.id} style={{background:'#FEF2F2',border:'2px solid #EF4444',borderRadius:'12px',padding:'14px',marginBottom:'10px'}}>
                      <div style={{fontSize:'12px',fontWeight:'700',color:'#DC2626',marginBottom:'6px'}}>PICKUP REQUESTED</div>
                      <div style={{fontSize:'15px',fontWeight:'700',color:'#0D0D0D',marginBottom:'2px'}}>{job.delivery_address}</div>
                      <div style={{fontSize:'13px',color:'#6B6B6B',marginBottom:'10px'}}>{job.size} · ${parseFloat(job.hauler_payout || 0).toFixed(0)} payout</div>
                      <button
                        onClick={function() { handlePickupComplete(job.id); }}
                        style={{width:'100%',padding:'10px',background:'#DC2626',color:'white',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                        Mark Pickup Complete
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            {offered.length > 0 && (
              <div className="h-section">
                <div className="h-section-hd" style={{color:'#D97706'}}>Job Offered to You</div>
                {offered.map(function(job) {
                  return (
                    <div key={job.id} style={{background:'#FFFBEB',border:'2px solid #F59E0B',borderRadius:'12px',padding:'14px',marginBottom:'10px'}}>
                      <div style={{fontSize:'12px',fontWeight:'700',color:'#D97706',marginBottom:'6px'}}>ACTION REQUIRED</div>
                      <div style={{fontSize:'15px',fontWeight:'700',color:'#0D0D0D',marginBottom:'2px'}}>{job.delivery_address}</div>
                      <div style={{fontSize:'13px',color:'#6B6B6B',marginBottom:'8px'}}>{job.size} · {formatDate(job.requested_delivery_date)} · ${parseFloat(job.hauler_payout || 0).toFixed(0)} payout</div>
                      <div style={{display:'flex',gap:'8px'}}>
                        <button onClick={function() { handleAccept(job.id); }}
                          style={{flex:1,padding:'9px',background:'#1A7A4A',color:'white',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                          Accept Job
                        </button>
                        <button onClick={function() { handleDecline(job.id); }}
                          style={{flex:1,padding:'9px',background:'white',color:'#EF4444',border:'1.5px solid #EF4444',borderRadius:'8px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}>
                          Decline
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="h-section">
              <div className="h-section-hd">My Active Jobs</div>
              {schedule.length === 0 && upcoming.length === 0 ? (
                <div style={{color:'#6B6B6B',fontSize:'13px'}}>No active jobs.</div>
              ) : (
                <div className="h-list-card">
                  {schedule.map(function(job) {
                    return (
                      <div className="h-job-row" key={job.id} onClick={function() { setSelectedJobId(job.id); }}>
                        <div className="h-job-date">{job.time}</div>
                        <div className="h-job-info">
                          <div className="h-job-addr">{job.address}</div>
                          <div className="h-job-meta">{job.action} · {job.size}</div>
                        </div>
                        <span className={'h-badge ' + job.status}>{job.status_label}</span>
                      </div>
                    );
                  })}
                  {upcoming.map(function(job) {
                    return (
                      <div className="h-job-row" key={job.id} onClick={function() { setSelectedJobId(job.id); }}>
                        <div className="h-job-date">{formatDate(job.requested_delivery_date)}</div>
                        <div className="h-job-info">
                          <div className="h-job-addr">{job.delivery_address}</div>
                          <div className="h-job-meta">{job.size} · ${parseFloat(job.hauler_payout || 0).toFixed(0)}</div>
                        </div>
                        <span className="h-badge scheduled">Scheduled</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        )}

        {/* SCHEDULE TAB */}
        {tab === 'schedule' && (
          <div>
            <div className="h-section" style={{paddingTop:'16px'}}>
              <div className="h-section-hd">Upcoming</div>
              {schedule.length === 0 && upcoming.length === 0 ? (
                <div style={{color:'#6B6B6B',fontSize:'13px'}}>No upcoming deliveries.</div>
              ) : (
                <div className="h-list-card">
                  {schedule.map(function(job) {
                    return (
                      <div className="h-job-row" key={'s-' + job.id} onClick={function() { setSelectedJobId(job.id); }}>
                        <div className="h-job-date">{job.time}</div>
                        <div className="h-job-info">
                          <div className="h-job-addr">{job.address}</div>
                          <div className="h-job-meta">{job.action} · {job.size}</div>
                        </div>
                        <span className={'h-badge ' + job.status}>{job.status_label}</span>
                      </div>
                    );
                  })}
                  {[...upcoming]
                    .sort(function(a, b) { return new Date(a.requested_delivery_date) - new Date(b.requested_delivery_date); })
                    .map(function(job) {
                      return (
                        <div className="h-job-row" key={'u-' + job.id} onClick={function() { setSelectedJobId(job.id); }}>
                          <div className="h-job-date">{formatDate(job.requested_delivery_date)}</div>
                          <div className="h-job-info">
                            <div className="h-job-addr">{job.delivery_address}</div>
                            <div className="h-job-meta">{job.size} · ${parseFloat(job.hauler_payout || 0).toFixed(0)}</div>
                          </div>
                          <span className="h-badge scheduled">Scheduled</span>
                        </div>
                      );
                    })
                  }
                </div>
              )}
            </div>

            {completed.length > 0 && (
              <div className="h-section" ref={completedListRef} style={{scrollMarginTop:'70px'}}>
                <div className="h-section-hd">Completed</div>
                <div className="h-list-card">
                  {completed.slice(0, completedVisible).map(function(job) {
                    const needsPickup = job.status === 'delivered' || job.status === 'active';
                    const rSt = jobRatings[job.id] || {};
                    const alreadyRated = job.my_rating || rSt.submitted;
                    const existingStars = job.my_rating || rSt.selected || 0;
                    const canRate = job.client_id && !needsPickup;
                    return (
                      <div key={job.id}>
                        <div className="h-job-row" onClick={function() { setSelectedJobId(job.id); }}>
                          <div className="h-job-date green">{formatDate(job.actual_delivered_at || job.requested_delivery_date)}</div>
                          <div className="h-job-info">
                            <div className="h-job-addr">{job.delivery_address}</div>
                            <div className="h-job-meta">{job.size} · ${parseFloat(job.hauler_payout || 0).toFixed(0)}</div>
                          </div>
                          <div style={{display:'flex',flexDirection:'column',gap:'4px',alignItems:'flex-end',flexShrink:0}}>
                            <span className={'h-badge ' + (needsPickup ? 'urgent' : 'delivered')}>
                              {needsPickup ? 'Pickup Needed' : 'Done'}
                            </span>
                            {needsPickup && (
                              <button
                                className="h-grab-btn"
                                style={{fontSize:'10px',padding:'4px 8px',background:'#1A7A4A',marginTop:'2px'}}
                                onClick={function(e) { e.stopPropagation(); handlePickupComplete(job.id); }}
                              >
                                Pickup Done
                              </button>
                            )}
                          </div>
                        </div>
                        {canRate && (
                          <div
                            onClick={function(e) { e.stopPropagation(); }}
                            style={{padding:'6px 12px 10px',borderTop:'1px solid #F3F4F6',background:'#FAFAFA'}}
                          >
                            {alreadyRated ? (
                              <div style={{display:'flex',alignItems:'center',gap:6}}>
                                <span style={{fontSize:'11px',color:'#9CA3AF'}}>Your rating:</span>
                                <span style={{fontSize:'16px',letterSpacing:'1px'}}>
                                  {[1,2,3,4,5].map(function(s) {
                                    return <span key={s} style={{color: s <= existingStars ? '#f59e0b' : '#D1D5DB'}}>★</span>;
                                  })}
                                </span>
                              </div>
                            ) : (
                              <div style={{display:'flex',alignItems:'center',gap:6,flexWrap:'wrap'}}>
                                <span style={{fontSize:'11px',color:'#6B6B6B',fontWeight:600}}>Rate client:</span>
                                {[1,2,3,4,5].map(function(star) {
                                  return (
                                    <button
                                      key={star}
                                      disabled={rSt.submitting}
                                      onClick={function(e) { e.stopPropagation(); rateClient(job, star); }}
                                      onMouseEnter={function() { setJobRatings(function(p) { return Object.assign({}, p, { [job.id]: Object.assign({}, p[job.id], { hover: star }) }); }); }}
                                      onMouseLeave={function() { setJobRatings(function(p) { return Object.assign({}, p, { [job.id]: Object.assign({}, p[job.id], { hover: 0 }) }); }); }}
                                      style={{background:'none',border:'none',padding:'0 1px',cursor:rSt.submitting?'not-allowed':'pointer',fontSize:'20px',color: star <= (rSt.hover || 0) ? '#f59e0b' : '#D1D5DB',lineHeight:1}}
                                    >★</button>
                                  );
                                })}
                                {rSt.error && <span style={{fontSize:'11px',color:'#DC2626',marginLeft:4}}>{rSt.error}</span>}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div style={{textAlign:'center',padding:'10px 14px 4px'}}>
                  <div style={{fontSize:'12px',color:'#9CA3AF',marginBottom:'8px'}}>
                    Showing {Math.min(completedVisible, completed.length)} of {completed.length}
                  </div>
                  <div style={{display:'flex',gap:'8px',justifyContent:'center',flexWrap:'wrap',marginBottom:'4px'}}>
                    {completed.length > completedVisible && (
                      <button
                        onClick={function() { setCompletedVisible(function(v) { return v + 10; }); }}
                        style={{background:'#1A7A4A',color:'white',border:'none',borderRadius:'8px',padding:'9px 24px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}
                      >
                        Show More
                      </button>
                    )}
                    {completedVisible > 10 && (
                      <button
                        onClick={function() { setCompletedVisible(10); completedListRef.current?.scrollIntoView({behavior:'smooth',block:'start'}); }}
                        style={{background:'transparent',color:'#1A7A4A',border:'2px solid #1A7A4A',borderRadius:'8px',padding:'7px 24px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}
                      >
                        Show Less
                      </button>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* EARNINGS TAB */}
        {tab === 'earnings' && (
          <div>
            <div className="h-earnings-top">
              <div className="h-earnings-total-card">
                <div className="h-earnings-total-lbl">Total Earned</div>
                <div className="h-earnings-total-val">${totalEarned.toFixed(0)}</div>
              </div>
              <div className="h-earnings-sub-row">
                <div className="h-stat-card">
                  <div className="h-stat-val" style={{fontSize:'20px'}}>${monthEarned.toFixed(0)}</div>
                  <div className="h-stat-lbl">This Month</div>
                </div>
                <div className="h-stat-card">
                  <div className="h-stat-val" style={{fontSize:'20px'}}>${stats.week_earnings}</div>
                  <div className="h-stat-lbl">This Week</div>
                </div>
                <div className="h-stat-card" style={{borderLeft:'3px solid #f59e0b'}}>
                  <div className="h-stat-val" style={{fontSize:'20px',color:'#f59e0b'}}>${completed.filter(function(j){return j.payout_status==='pending';}).reduce(function(s,j){return s+parseFloat(j.hauler_payout||0);},0).toFixed(0)}</div>
                  <div className="h-stat-lbl">Pending</div>
                </div>
              </div>
            </div>

            <div className="h-section" ref={payoutListRef} style={{scrollMarginTop:'70px'}}>
              <div className="h-section-hd">Payout History</div>
              {completed.length === 0 ? (
                <div style={{color:'#6B6B6B',fontSize:'13px'}}>No completed jobs yet.</div>
              ) : (
                <>
                <div className="h-list-card">
                  {completed.slice(0, payoutVisible).map(function(job) {
                    return (
                      <div className="h-payout-row" key={job.id} onClick={function() { setSelectedJobId(job.id); }} style={{cursor:'pointer'}}>
                        <div>
                          <div className="h-job-addr">{job.delivery_address}</div>
                          <div className="h-job-meta">{job.size} · {formatDate(job.actual_delivered_at || job.requested_delivery_date)}</div>
                        </div>
                        <div style={{display:'flex',alignItems:'center',gap:'8px',flexShrink:0}}>
                          {job.payout_status === 'paid' ? (
                            <span style={{fontSize:'10px',fontWeight:'700',padding:'2px 7px',borderRadius:'20px',background:'#f0fdf4',color:'#1A7A4A',border:'1px solid #bbf7d0',whiteSpace:'nowrap'}}>✓ Paid</span>
                          ) : job.payout_status === 'pending' ? (
                            <span style={{fontSize:'10px',fontWeight:'700',padding:'2px 7px',borderRadius:'20px',background:'#fffbeb',color:'#f59e0b',border:'1px solid #fde68a',whiteSpace:'nowrap'}}>Pending</span>
                          ) : null}
                          <div className="h-payout-amount">${parseFloat(job.hauler_payout || 0).toFixed(0)}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{textAlign:'center',padding:'10px 14px 4px'}}>
                  <div style={{fontSize:'12px',color:'#9CA3AF',marginBottom:'8px'}}>
                    Showing {Math.min(payoutVisible, completed.length)} of {completed.length}
                  </div>
                  <div style={{display:'flex',gap:'8px',justifyContent:'center',flexWrap:'wrap',marginBottom:'4px'}}>
                    {completed.length > payoutVisible && (
                      <button
                        onClick={function() { setPayoutVisible(function(v) { return v + 10; }); }}
                        style={{background:'#1A7A4A',color:'white',border:'none',borderRadius:'8px',padding:'9px 24px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}
                      >
                        Show More
                      </button>
                    )}
                    {payoutVisible > 10 && (
                      <button
                        onClick={function() { setPayoutVisible(10); payoutListRef.current?.scrollIntoView({behavior:'smooth',block:'start'}); }}
                        style={{background:'transparent',color:'#1A7A4A',border:'2px solid #1A7A4A',borderRadius:'8px',padding:'7px 24px',fontSize:'13px',fontWeight:'700',cursor:'pointer'}}
                      >
                        Show Less
                      </button>
                    )}
                  </div>
                </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* PROFILE TAB */}
        {tab === 'profile' && (
          <div style={{padding:'16px 14px 20px'}}>
            <div className="h-card" style={{marginBottom:'14px'}}>
              <div className="h-card-title">Contact Info</div>
              <div className="h-form-field">
                <label className="h-form-label">Company Name</label>
                <input className="h-form-input" placeholder="e.g. Acme Hauling LLC" value={companyName} onChange={function(e){setCompanyName(e.target.value);}} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">First Name</label>
                <input className="h-form-input" placeholder="John" value={firstName} onChange={function(e){setFirstName(e.target.value);}} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">Last Name</label>
                <input className="h-form-input" placeholder="Smith" value={lastName} onChange={function(e){setLastName(e.target.value);}} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">Cell Phone</label>
                <input className="h-form-input" type="tel" placeholder="(555) 555-5555" value={phone} onChange={function(e){setPhone(e.target.value);}} />
              </div>
              <div className="h-form-field" style={{marginBottom:'0'}}>
                <label className="h-form-label">Email</label>
                <input className="h-form-input" type="email" value={email} disabled />
                <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'4px'}}>Email cannot be changed here.</div>
              </div>
            </div>

            <div className="h-card" style={{marginBottom:'14px'}}>
              <div className="h-card-title">
                Home Base
                {locationSaved && <span style={{color:'#1A7A4A',fontSize:'11px',fontWeight:'600',textTransform:'none',letterSpacing:'0',marginLeft:'8px'}}>📍 Saved</span>}
              </div>
              <div className="h-form-field">
                <label className="h-form-label">City</label>
                <input className="h-form-input" placeholder='e.g. "Harlingen, TX"' value={homeBaseCity} onChange={function(e){setHomeBaseCity(e.target.value);}} />
                <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'4px'}}>Enter city and state — we'll pin your location automatically.</div>
              </div>
              <div className="h-form-field" style={{marginBottom:'0'}}>
                <label className="h-form-label">Service Radius</label>
                <select className="h-form-input" style={{appearance:'none'}} value={serviceRadius} onChange={function(e){setServiceRadius(parseInt(e.target.value));}}>
                  {[15,25,35,50,75,100].map(function(r){
                    return <option key={r} value={r}>{r} miles</option>;
                  })}
                </select>
                <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'4px'}}>Jobs within this radius will be offered to you.</div>
              </div>
            </div>

            {profileError && <div className="h-error">{profileError}</div>}
            {profileSaved && <div className="h-success">Profile saved!</div>}
            <button className="h-btn" onClick={handleSaveProfile} disabled={profileSaving} style={{marginBottom:'20px'}}>
              {profileSaving ? 'Saving...' : 'Save Profile'}
            </button>

            <div className="h-card" style={{marginBottom:'14px'}}>
              <div className="h-card-title">Change Password <span style={{fontSize:'11px',fontWeight:500,color:'#9CA3AF',textTransform:'none',letterSpacing:0}}>/ Cambiar Contraseña</span></div>
              <div className="h-form-field">
                <label className="h-form-label">New Password / Nueva Contraseña</label>
                <input
                  className="h-form-input"
                  type="password"
                  placeholder="At least 8 characters / Mínimo 8 caracteres"
                  value={newPwd}
                  onChange={function(e) { setNewPwd(e.target.value); setPwdError(''); setPwdSaved(false); }}
                />
              </div>
              <div className="h-form-field" style={{marginBottom:'0'}}>
                <label className="h-form-label">Confirm Password / Confirmar Contraseña</label>
                <input
                  className="h-form-input"
                  type="password"
                  placeholder="Repeat your password / Repite tu contraseña"
                  value={newPwdConfirm}
                  onChange={function(e) { setNewPwdConfirm(e.target.value); setPwdError(''); setPwdSaved(false); }}
                />
              </div>
              {pwdError && <div className="h-error" style={{marginTop:'8px'}}>{pwdError}</div>}
              {pwdSaved && <div className="h-success" style={{marginTop:'8px'}}>✅ Password updated! / ¡Contraseña actualizada!</div>}
              <button className="h-btn" onClick={handleChangePassword} disabled={pwdSaving} style={{marginTop:'12px'}}>
                {pwdSaving ? 'Saving... / Guardando...' : 'Update Password / Actualizar Contraseña'}
              </button>
            </div>

            <div className="h-card">
              <div className="h-card-title">Inventory</div>
              <div style={{marginBottom:'14px'}}>
                <label className="h-form-label">Service ZIP Codes</label>
                <input className="h-form-input" placeholder="e.g. 30301, 30302, 78520" value={zips} onChange={function(e){setZips(e.target.value);}} />
                <div style={{fontSize:'11px',color:'#9CA3AF',marginTop:'4px'}}>Separate multiple ZIPs with commas</div>
              </div>
              {(function() {
                var available   = SIZES.filter(function(s) { return (inventory[s] || {}).is_available !== false; });
                var unavailable = SIZES.filter(function(s) { return (inventory[s] || {}).is_available === false; });
                var ratesIcon = (
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:'4px'}}>
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                );
                return (
                  <React.Fragment>
                    {available.map(function(size, i) {
                      var item = inventory[size] || {};
                      var qty  = parseInt(item.quantity) || 0;
                      return (
                        <div className="h-inv-item" key={size}
                          style={{borderBottom: i < available.length - 1 ? '1px solid #F0F0EE' : 'none'}}
                        >
                          <div className="h-inv-item-top">
                            <div className="h-inv-size-label">{SIZE_LABELS[size]}</div>
                            <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
                              <button className="h-rates-btn" onClick={function() { openRatesModal(size); }}>
                                {ratesIcon}Rates
                              </button>
                              <button
                                className="h-toggle on"
                                onClick={function() { updateInv(size, 'is_available', item.is_available === false); }}
                              >
                                Available
                              </button>
                            </div>
                          </div>
                          <div className="h-qty-row">
                            <span className="h-qty-label">Qty</span>
                            <button className="h-qty-btn" onClick={function() { updateInv(size, 'quantity', Math.max(0, qty - 1)); }}>−</button>
                            <span className="h-qty-val">{qty}</span>
                            <button className="h-qty-btn" onClick={function() { updateInv(size, 'quantity', qty + 1); }}>+</button>
                          </div>
                        </div>
                      );
                    })}
                    {unavailable.length > 0 && available.length > 0 && (
                      <div style={{fontSize:'11px',fontWeight:'700',color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'0.06em',padding:'14px 0 10px',borderTop:'1px solid #F0F0EE'}}>
                        Not currently offering
                      </div>
                    )}
                    {unavailable.map(function(size, i) {
                      var item   = inventory[size] || {};
                      var isLast = i === unavailable.length - 1;
                      return (
                        <div key={size} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:isLast?'10px 0 0':'10px 0',borderBottom:isLast?'none':'1px solid #F0F0EE'}}>
                          <div style={{fontSize:'14px',fontWeight:'600',color:'#9CA3AF'}}>{SIZE_LABELS[size]}</div>
                          <button
                            className="h-toggle"
                            onClick={function() { updateInv(size, 'is_available', item.is_available === false); }}
                          >
                            Off
                          </button>
                        </div>
                      );
                    })}
                  </React.Fragment>
                );
              })()}
            </div>

            {inventorySaved && <div className="h-success" style={{marginTop:'12px'}}>Inventory saved!</div>}
            <button className="h-btn" onClick={handleSaveInventory} disabled={inventorySaving} style={{marginTop:'14px'}}>
              {inventorySaving ? 'Saving...' : 'Save Inventory'}
            </button>
          </div>
        )}

      </main>

      {/* RATES MODAL */}
      {ratesModal && (
        <div className="h-modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) { setRatesModal(null); setRatesSaved(false); } }}>
          <div className="h-modal-card">
            <div className="h-modal-header">
              <div className="h-modal-title">{SIZE_LABELS[ratesModal]} Rates</div>
              <button className="h-modal-close" onClick={function() { setRatesModal(null); setRatesSaved(false); }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
            <div className="h-modal-body">
              <div className="h-form-field">
                <label className="h-form-label">3-Day Rate ($)</label>
                <input className="h-form-input" type="number" min="0" placeholder="0"
                  value={ratesDraft.rate_3day}
                  onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { rate_3day: e.target.value }); }); }} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">5-Day Rate ($)</label>
                <input className="h-form-input" type="number" min="0" placeholder="0"
                  value={ratesDraft.rate_5day}
                  onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { rate_5day: e.target.value }); }); }} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">7-Day Rate ($)</label>
                <input className="h-form-input" type="number" min="0" placeholder="0"
                  value={ratesDraft.rate_7day}
                  onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { rate_7day: e.target.value }); }); }} />
              </div>
              <div className="h-form-field">
                <label className="h-form-label">Extra Day Rate ($)</label>
                <input className="h-form-input" type="number" min="0" placeholder="0"
                  value={ratesDraft.rate_extra_day}
                  onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { rate_extra_day: e.target.value }); }); }} />
              </div>
              <div style={{borderTop:'1px solid #F0F0EC',margin:'4px 0 12px',paddingTop:'12px'}}>
                <div style={{fontSize:'11px',fontWeight:'700',color:'#9CA3AF',letterSpacing:'0.05em',textTransform:'uppercase',marginBottom:'10px'}}>Tonnage &amp; Overage Terms</div>
                <div className="h-form-field">
                  <label className="h-form-label">Included Days</label>
                  <input className="h-form-input" type="number" min="1" placeholder="3"
                    value={ratesDraft.included_days}
                    onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { included_days: e.target.value }); }); }} />
                </div>
                <div className="h-form-field">
                  <label className="h-form-label">Included Tonnage (tons)</label>
                  <input className="h-form-input" type="number" min="0" step="0.5" placeholder="2"
                    value={ratesDraft.included_tonnage}
                    onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { included_tonnage: e.target.value }); }); }} />
                </div>
                <div className="h-form-field">
                  <label className="h-form-label">Daily Rate — per extra day ($)</label>
                  <input className="h-form-input" type="number" min="0" placeholder="0"
                    value={ratesDraft.daily_rate}
                    onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { daily_rate: e.target.value }); }); }} />
                </div>
                <div className="h-form-field" style={{marginBottom:'0'}}>
                  <label className="h-form-label">Overage Per Ton — over included ($)</label>
                  <input className="h-form-input" type="number" min="0" placeholder="0"
                    value={ratesDraft.overage_per_ton}
                    onChange={function(e) { setRatesDraft(function(p) { return Object.assign({}, p, { overage_per_ton: e.target.value }); }); }} />
                </div>
              </div>
            </div>
            {ratesSaved && <div className="h-success" style={{margin:'12px 16px 0'}}>Rates saved!</div>}
            <div className="h-modal-footer">
              <button className="h-btn" onClick={handleSaveRates} disabled={ratesSaving}>
                {ratesSaving ? 'Saving...' : 'Save Rates'}
              </button>
            </div>
          </div>
        </div>
      )}

      <nav className="h-bottom-nav">
        <button className={'h-tab-btn' + (tab === 'home' ? ' active' : '')} onClick={function() { setTab('home'); }}>
          <IconHome active={tab === 'home'} />
          <span className="h-tab-label">Home</span>
        </button>
        <button className={'h-tab-btn' + (tab === 'jobs' ? ' active' : '')} onClick={function() { setTab('jobs'); }}>
          <IconBriefcase active={tab === 'jobs'} />
          <span className="h-tab-label">Jobs</span>
        </button>
        <button className={'h-tab-btn' + (tab === 'schedule' ? ' active' : '')} onClick={function() { setTab('schedule'); }}>
          <IconCalendar active={tab === 'schedule'} />
          <span className="h-tab-label">Schedule</span>
        </button>
        <button className={'h-tab-btn' + (tab === 'earnings' ? ' active' : '')} onClick={function() { setTab('earnings'); }}>
          <IconCoin active={tab === 'earnings'} />
          <span className="h-tab-label">Earnings</span>
        </button>
        <button className={'h-tab-btn' + (tab === 'profile' ? ' active' : '')} onClick={function() { setTab('profile'); }}>
          <IconUser active={tab === 'profile'} />
          <span className="h-tab-label">Profile</span>
        </button>
      </nav>
    </div>
  );
}

function Hauler() {
  const [page, setPage] = useState('loading');
  const [user, setUser] = useState(null);

  const checkHaulerStatus = async function(uid) {
    try {
      const res = await fetch(BACKEND + '/api/haulers/me?user_id=' + uid);
      const data = await res.json();
      return data.hauler ? data.hauler.status : 'pending';
    } catch (e) {
      return 'pending';
    }
  };

  useEffect(function() {
    supabase.auth.getSession().then(async function(result) {
      if (result.data.session) {
        const u = result.data.session.user;
        setUser(u);
        const status = await checkHaulerStatus(u.id);
        setPage(status === 'approved' ? 'home' : status === 'suspended' ? 'suspended' : 'pending');
      } else {
        setPage('login');
      }
    });
  }, []);

  const handleSignOut = async function() {
    await supabase.auth.signOut();
    window.location.href = '/login';
  };

  if (page === 'loading') {
    return (
      <div style={{background:'#1A7A4A',minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
        <div style={{color:'white',fontSize:'18px',fontWeight:'700'}}>Loading...</div>
      </div>
    );
  }

  if (page === 'login') {
    return (
      <LoginPage onLogin={async function(u) {
        setUser(u);
        const status = await checkHaulerStatus(u.id);
        setPage(status === 'approved' ? 'home' : status === 'suspended' ? 'suspended' : 'pending');
      }} />
    );
  }

  if (page === 'pending') {
    return <PendingPage onSignOut={handleSignOut} />;
  }

  if (page === 'suspended') {
    return <SuspendedPage onSignOut={handleSignOut} />;
  }

  return <HaulerDashboard user={user} onSignOut={handleSignOut} />;
}

export default Hauler;
